export default {
  search: {
    title: 'Request for Information',
    filters: {
      filter1: {
        placeholder: 'Search by ID Request, Description Request',
        button: 'Search',
      },
      filter3: {
        label1: 'ID Request',
        label2: 'Name',
        label3: 'Creation Date',
        label4: 'Close date',
        column5: {
          label1: 'Summary',
          content1: 'Guests',
          content2: 'Reviewed',
          content3: 'Answered',
        },
        column6: {
          label1: 'Status',
          label2: 'Posted',
          label3: 'Closed',
        },
        link1: 'See RFI',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/request_information/search.js